import { render, staticRenderFns } from "./security.vue?vue&type=template&id=ca76c31a&"
import script from "./security.vue?vue&type=script&lang=ts&"
export * from "./security.vue?vue&type=script&lang=ts&"
import style0 from "./security.vue?vue&type=style&index=0&id=ca76c31a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports